'use strict';

exports.__esModule = true;
exports.Menu = exports.Job = exports.common = exports.checker = exports.check = undefined;

var _apiCheck = require('api-check');

var _apiCheck2 = _interopRequireDefault(_apiCheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checker is an instance of apiCheck with a custom config
 * @ignore
 */
var checker = (0, _apiCheck2.default)({
  /* config options */
  output: {
    prefix: 'QuiqupJS',
    suffix: '',
    docsBaseUrl: 'http://api.quiqup.com/api_docs#'
  },
  verbose: process.env.NODE_ENV !== 'production',
  disabled: process.env.NODE_ENV === 'production'
});

/**
 * Job shape checks object for Job model data
 * @ignore
 */
var Job = [checker.shape({
  transportMode: checker.oneOf(['car', 'scooter', 'bike']).optional,
  kind: checker.oneOf(['partner_scheduled', 'partner_on_demand']).optional
})];

/**
 * Menu shape checks object for Menu model data
 * @ignore
 */
var Menu = [checker.shape({
  menuId: checker.number,
  productId: checker.number
}).strict];

/**
 * Common checks with custom warning/error messages
 * @ignore
 */
var common = {
  jobId: function jobId(val, name, location) {
    var type = "A valid order number, if you are still using job 'id' this will soon be deprecated.";
    var result = void 0;

    if (!/\-*\-/.test(val)) {
      result = _apiCheck2.default.utils.getError(name, location, type);
    }

    return result;
  },

  event: checker.oneOf(['venue_transmit', 'venue_accept', 'venue_reject', 'start', 'placed', 'failed', 'ready']).optional
};

/**
 * @ignore
 */
exports.check = _apiCheck2.default;
exports.checker = checker;
exports.common = common;
exports.Job = Job;
exports.Menu = Menu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/utils/qu-check.js
// module id = 96
// module chunks = 0